import React from "react";
import { NavLink as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Button, ListItem, makeStyles } from "@material-ui/core";
import List from "@material-ui/core/List";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Badge from "@material-ui/core/Badge";
import { withStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  item: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
  },
  button: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
    justifyContent: "flex-start",
    letterSpacing: 0,
    padding: "10px 8px",
    textTransform: "none",
    width: "100%",
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  title: {
    marginRight: "auto",
  },
  active: {
    color: theme.palette.primary.main,
    "& $title": {
      fontWeight: theme.typography.fontWeightMedium,
    },
    "& $icon": {
      color: theme.palette.primary.main,
    },
  },
  itemnested: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: theme.spacing(3),
  },
}));

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: 8,
    border: `0px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}))(Badge);

const NavBarItem = ({
  className,
  href,
  keyVal,
  icon: Icon,
  expandable,
  children,
  title,
  badge,
  userPermissions,
  reloadPath,
  ...rest
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const reloadIfTheSamePath = (path) => {
    if (path && window.location.toString().endsWith(path)) {
      window.location.reload();
    }
  };

  return (
    <div>
      {badge > 0 ? (
        <ListItem key={keyVal} className={clsx(classes.item, className)} {...rest}>
          {expandable ? (
            <Button key={`btn_${keyVal}`} className={classes.button} onClick={() => handleClick()}>
              {Icon && <Icon className={classes.icon} size="20" />}
              <span className={classes.title}>{title}</span>
              {open ? <ExpandLess /> : <ExpandMore />}
            </Button>
          ) : (
            <Button key={`btn_${keyVal}`} 
              activeclassname={classes.active}
              className={classes.button}
              component={RouterLink}
              onClick={() => reloadIfTheSamePath(reloadPath)}
              to={href}
            >
              {Icon && (
                <StyledBadge
                  badgeContent={badge}
                  color="error"
                  className={classes.item}
                >
                  <Icon className={classes.icon} size="20" />
                </StyledBadge>
              )}
              <span className={classes.title}>{title}</span>
            </Button>
          )}
        </ListItem>
      ) : (
        <ListItem key={keyVal} className={clsx(classes.item, className)} {...rest}>
          {expandable ? (
            <Button key={`btn_${keyVal}`} className={classes.button} onClick={() => handleClick()}>
              {Icon && <Icon className={classes.icon} size="20" />}
              <span className={classes.title}>{title}</span>
              {open ? <ExpandLess /> : <ExpandMore />}
            </Button>
          ) : (
            <Button key={`btn_${keyVal}`} 
              activeclassname={classes.active}
              className={classes.button}
              component={RouterLink}
              to={href}
            >
              {Icon && <Icon className={classes.icon} size="20" />}
              <span className={classes.title}>{title}</span>
            </Button>
          )}
        </ListItem>
      )}

      {expandable ? (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {children.map((item,index) => (
              <ListItem
                key={`${keyVal}_${item.title}${index}`}
                className={clsx(classes.itemnested, className)}
                {...rest}
              >
                <Button key={`btn_${keyVal}`} 
                  disabled={item.disabled && true}
                  activeclassname={classes.active}
                  className={classes.button}
                  component={RouterLink}
                  to={item.href}
                >
                  {item.icon && (
                    <item.icon className={classes.icon} size="20" />
                  )}
                  <span className={classes.title}>{item.title}</span>
                </Button>
              </ListItem>
            ))}
          </List>
        </Collapse>
      ) : (
        <></>
      )}
    </div>
  );
};

NavBarItem.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string,
};

export default NavBarItem;
